import { Dropper } from "@hl/base-components/lib/assets/icons/HDS";
import { Box, ColorInput } from "@mantine/core";

import { CSSColorToHex } from "../utils";

export const ColorPropertyField = (props: {
  value: string;
  defaultValue: string;
  hasValue: boolean;
  onChange: (value: string | null) => void;
}) => {
  const { value, defaultValue, hasValue, onChange } = props;
  const valueAsString = hasValue ? value : "";

  return (
    <ColorInput
      size="xs"
      placeholder={defaultValue}
      value={valueAsString}
      onChange={(v) => {
        // TODO jj: A debounce would be nice here
        onChange(CSSColorToHex(v));
      }}
      eyeDropperIcon={<Dropper height={14} />}
      rightSectionProps={{
        style: {
          background: "transparent",
        },
      }}
      icon={
        <Box
          sx={{
            width: "16px",
            height: "16px",
            borderRadius: "4px",
            background: valueAsString,
            border: "1px solid var(--mantine-color-gray-4)",
          }}
        ></Box>
      }
      styles={{
        input: {
          padding: "0 8px",
          height: "40px",
          margin: 0,
        },
        rightSection: {
          paddingRight: 8,
          button: {
            height: "28px",
            width: "28px",
            minWidth: "28px",
            background: "var(--mantine-color-gray-3)",
            padding: "4px",
          },
        },
      }}
    />
  );
};
